var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view--home"},[_c('p',[_vm._v("Choose your plan:")]),_c('router-link',{attrs:{"to":"/process"}},[_vm._v("Demo Process")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }